import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
} from '@mui/material';
import { useRootStore } from '../../../../stores/rootStore';

const OCCUPATION_METRICS_AU = [
  {
    groupMetricId: '119',
    metricId: '1264',
    displayName: 'Occupation: Professional',
    definition:
      'The percentage of residents working in a Professional occupation for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1265',
    displayName: ' Occupation: Clerical and Administrative Workers ',
    definition:
      'The percentage of residents working in a Clerical occupation for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1266',
    displayName: 'Occupation: Technicians and Trades Workers',
    definition:
      'The percentage of residents working in a Trades occupation for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1267',
    displayName: 'Occupation: Labourer',
    definition:
      'The percentage of residents working in a Labourer occupation for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1268',
    displayName: 'Occupation: Not Stated',
    definition:
      'The percentage of residents working in an Other occupation for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1315',
    displayName: 'Occupation: Machinery Operators and Drivers',
    definition:
      'The percentage of residents working in a Machinery Operators and Driver occupation for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1316',
    displayName: 'Occupation: Managers',
    definition:
      'The percentage of residents working in a Manager occupation for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1317',
    displayName: ' Occupation: Community and Personal Service Workers ',
    definition:
      'The percentage of residents working in a Community and Personal Service occupation for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1318',
    displayName: 'Occupation: Sales Workers',
    definition:
      'The percentage of residents working in a Sales occupation for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
];

const TRANSPORT_METRICS_AU = [
  {
    groupMetricId: '111',
    metricId: '1181',
    displayName: 'Transport to Work: Bicycle',
    definition:
      'The percentage of residents that use a Bicycle to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1182',
    displayName: 'Transport to Work: Bus',
    definition:
      'The percentage of residents that use a Bus to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1183',
    displayName: 'Transport to Work: Car (Drive)',
    definition:
      'The percentage of residents that use a Car (Drive) to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1184',
    displayName: 'Transport to Work: Car (Passenger)',
    definition:
      'The percentage of residents that use a Car (Passenger) to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1185',
    displayName: 'Transport to Work: Ferry',
    definition:
      'The percentage of residents that use a Ferry to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1186',
    displayName: 'Transport to Work: Motorbike',
    definition:
      'The percentage of residents that use a Motorbike to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1187',
    displayName: 'Transport to Work: Other',
    definition:
      'The percentage of residents that use Other methods to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1188',
    displayName: 'Transport to Work: Taxi',
    definition:
      'The percentage of residents that use a Taxi to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1189',
    displayName: 'Transport to Work: Train',
    definition:
      'The percentage of residents that use a Train to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1190',
    displayName: 'Transport to Work: Tram',
    definition:
      'The percentage of residents that use a Tram to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1191',
    displayName: 'Transport to Work: Truck',
    definition:
      'The percentage of residents that use a Truck to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1192',
    displayName: 'Transport to Work: Walk',
    definition:
      'The percentage of residents that Walk to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1310',
    displayName: 'Transport to Work: Did not Travel',
    definition:
      'The percentage of residents that Did not Travel to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1311',
    displayName: 'Transport to Work: Not Stated',
    definition:
      'The percentage of residents that Did not state how they get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1312',
    displayName: 'Transport to Work: Three Methods of Transport',
    definition:
      'The percentage of residents that used three methods of transport to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1313',
    displayName: 'Transport to Work: Two Methods of Transport',
    definition:
      'The percentage of residents that used two methods of transport to get to work for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1314',
    displayName: 'Transport to Work: Work from Home',
    definition:
      'The percentage of residents that worked from home for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
];

const EMPLOYMENT_METRICS_NZ = [
  {
    groupMetricId: '116',
    metricId: '1229',
    displayName: 'Employment: Unemployed',
    definition:
      'The percentage of residents that are Unemployed for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1415',
    displayName: 'Employed Part-time',
    definition:
      'The percentage of residents that are Part-time Employed for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1416',
    displayName: 'Employed Full-time',
    definition:
      'The percentage of residents that are Full-time Employed for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1417',
    displayName: 'Not in the Labour Force',
    definition:
      'The percentage of residents that are Not in labour force for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1449',
    displayName: 'Work and Labour Force Status Unidentifiable',
    definition:
      'The percentage of residents that are Work and Labour Force Status Unidentifiable for the geographical area. This metric is available for 2023.',
  },
];

const OCCUPATION_METRICS_NZ = [
  {
    groupMetricId: '115',
    metricId: '1218',
    displayName: 'Occupation: Professionals',
    definition:
      'The percentage of residents working in a Professional occupation for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1421',
    displayName: 'Occupation: Clerical And Administrative workers',
    definition:
      'The percentage of residents working in a Clerical And Administrative workers occupation for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1422',
    displayName: 'Occupation: Community and Personal Service workers',
    definition:
      'The percentage of residents working in a Community and Personal Service workers occupation for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1423',
    displayName: 'Occupation: Labourers',
    definition:
      'The percentage of residents working in a Labourers occupation for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1424',
    displayName: 'Occupation: Residual Categories (Operational Codes only)',
    definition:
      'The percentage of residents working in a Residual Categories occupation for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1425',
    displayName: 'Occupation: Machinery Operators and Drivers',
    definition:
      'The percentage of residents working in a Machinery Operators and Drivers occupation for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1426',
    displayName: 'Occupation: Managers',
    definition:
      'The percentage of residents working in a Managers occupation for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1427',
    displayName: 'Occupation: Technicians and Trades Workers',
    definition:
      'The percentage of residents working in a Technicians and Trades Workers occupation for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1428',
    displayName: 'Occupation: Sales Workers',
    definition:
      'The percentage of residents working in a Total occupation for the geographical area. This metric is available for 2023.',
  },
];

export const EmploymentAndOccupationMetrics = () => {
  const country = useRootStore(state => state.country);

  const metrics = [
    {
      title: 'Occupation',
      data: country === 'au' ? OCCUPATION_METRICS_AU : OCCUPATION_METRICS_NZ,
    },
    {
      title: 'Transport to Work',
      data: country === 'au' ? TRANSPORT_METRICS_AU : [],
    },
    {
      title: 'Employment',
      data: country === 'au' ? [] : EMPLOYMENT_METRICS_NZ,
    },
  ];

  return (
    <div>
      <Typography
        id="employment-and-occupation-metrics"
        variant="h6"
        fontWeight={600}
        my={0.5}
      >
        Employment & Occupation Metrics
      </Typography>

      <Typography variant="body2">
        The Employment & Occupation Metrics relates to the employment status,
        occupation type and method of travel to work of residents for a
        particular location.
      </Typography>

      <br />

      <Stack gap={4}>
        {metrics
          .filter(metric => metric.data.length > 0)
          .map(metric => (
            <div>
              <Typography variant="body2" fontWeight={600}>
                {metric.title}
              </Typography>

              <br />

              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ whiteSpace: 'nowrap' }}>
                    <TableRow>
                      <TableCell>Group Metric ID</TableCell>
                      <TableCell>Metric ID</TableCell>
                      <TableCell>Display Name</TableCell>
                      <TableCell>Definition</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {metric.data.map(data => (
                      <TableRow key={data.metricId}>
                        {data.groupMetricId && (
                          <TableCell rowSpan={metric.data.length}>
                            {data.groupMetricId}
                          </TableCell>
                        )}
                        <TableCell>{data.metricId}</TableCell>
                        <TableCell>{data.displayName}</TableCell>
                        <TableCell>{data.definition}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ))}
      </Stack>
    </div>
  );
};
